// export const BASE_URL = 'http://192.168.2.34:3000/v1/'
// export const BASE_URL = 'http://192.168.2.105:3000/v1/'
// export const BASE_URL='https://api-letsgather.netsetsoftware.pro/v1/'
export const BASE_URL= 'https://api.letsgatherinfo.com/v1'
export const REFRESH_TOKEN_URL = `${BASE_URL}genrate-refresh-token`
